// @constants
const { BROKER_ADVANCED_SEARCH_VIEW_SIMPLE_SEARCH_TAB } = require('constants/index');
const actionTypes = require('constants/actionTypes');

// @actions
const BrokerSimpleSearchActions = require('actions/brokerSimpleSearch');
const getResultsList = require('./brokerAdvancedSearch/brokerAdvancedSearchGetResultsListRequest');
const getFilters = require('./brokerAdvancedSearch/brokerAdvancedSearchGetFiltersRequest');

// @constants
const { BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT } = require('constants/index');

const changeTab = (tab) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_ADVANCED_SEARCH_CHANGE_TAB,
        payload: { tab }
    });
};

const performSimpleSearch = (term) => (dispatch) => {
    changeTab(BROKER_ADVANCED_SEARCH_VIEW_SIMPLE_SEARCH_TAB)(dispatch);
    BrokerSimpleSearchActions.changeSearchInput(term)(dispatch);
    BrokerSimpleSearchActions.searchProducts(term, BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT)(dispatch);
};

const handleFieldChange = (field, value) => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_FIELD_CHANGE,
        payload: {
            field,
            value
        }
    };
};

const clearResults = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_CLEAR_RESULTS
    };
};

const saveCheckedList = checkedItem => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_SAVE_CHECKED_LIST,
        checkedItem
    };
};

const reset = () => {
    return {
        type: actionTypes.BROKER_ADVANCED_SEARCH_RESET,
    };
};

module.exports = {
    changeTab,
    performSimpleSearch,
    handleFieldChange,
    getResultsList,
    saveCheckedList,
    clearResults,
    getFilters,
    reset
};
